<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <form autocomplete="off">
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col hidden lg:block lg:w-1/2">
                <img
                  src="@/assets/images/logo/sbt-caravanas-logo.png"
                  alt="login"
                  class="w-1/2 m-auto"
                />
              </div>

              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div class="login-tabs-container">
                  <div class="vx-card__title mb-4">
                    <h4 class="mb-4">Login</h4>
                  </div>

                  <div>
                    <vs-row class="mb-3">
                      <vs-col class="w-1/4"
                        ><vs-input
                          name="ddd"
                          id="ddd"
                          v-mask="'##'"
                          label-placeholder="DDD"
                          v-model="ddd"
                          pattern="[0-9]*"
                          class="w-2/3"
                          maxlength="2"
                          data-vv-as="'DDD'"
                          v-validate="'required|digits:2'"
                      /></vs-col>
                      <vs-col class="w-3/4"
                        ><vs-input
                          name="cellphone"
                          id="cellphone"
                          type="tel"
                          v-mask="'#########'"
                          label-placeholder="Celular"
                          v-model="cellphone"
                          pattern="[0-9]*"
                          class="w-full"
                          maxlength="9"
                          data-vv-as="'Celular'"
                          v-validate="'required|digits:9'"
                      /></vs-col>
                    </vs-row>
                    <vs-row
                      v-show="errors.has('ddd') || errors.has('cellphone')"
                    >
                      <vs-col>
                        <span
                          class="text-danger text-sm"
                          id="ddd"
                          v-show="errors.has('ddd')"
                          >{{ errors.first('ddd') }}</span
                        >
                        <span
                          class="text-danger text-sm"
                          id="cellphone"
                          v-show="errors.has('cellphone')"
                          >{{ errors.first('cellphone') }}</span
                        >
                      </vs-col>
                    </vs-row>

                    <vs-row>
                      <vs-col
                        ><vs-input
                          name="password"
                          id="password"
                          type="tel"
                          v-mask="'####'"
                          label-placeholder="Senha"
                          v-model="password"
                          class="w-full mt-6 password-input"
                          maxlength="4"
                          data-vv-as="'Senha'"
                          v-validate="'required|digits:4'"
                      /></vs-col>
                    </vs-row>
                    <vs-row class="mt-5">
                      <vs-col class="w-full">
                        <span
                          v-if="errors.has('password')"
                          class="text-danger w-full text-sm"
                          >{{ errors.first('password') }}</span
                        >
                        <span
                          id="message-error"
                          v-if="errorMsg"
                          class="text-danger w-full text-sm"
                          >{{ errorMsg }}</span
                        >
                      </vs-col>
                      <vs-col class="w-full">
                        <vs-button
                          @click="signIn"
                          :disabled="!isButtonReady"
                          class="float-right"
                          id="button-with-loading"
                          >Login</vs-button
                        >
                      </vs-col>
                    </vs-row>

                    <vs-row class="mt-5 w-full flex password-recovery">
                      <vs-col class="ml-auto flex">
                        <span class="mr-auto flex password-recovery-title">
                          <span class="text">Problemas de acesso?</span>
                        </span>
                        <router-link
                          to="/recuperar-senha"
                          class="ml-auto flex password-recovery-link"
                        >
                          <span class="text">Recuperar Senha</span>
                        </router-link>
                      </vs-col>
                    </vs-row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue'
import Vue from 'vue'
import { strings } from '@/utils/strings'
import { mask } from 'vue-the-mask'

import appStore from '@/store/store'

export default {
  data() {
    return {
      ddd: '11',
      cellphone: '',
      password: '',
      errorMsg: null,
    }
  },
  directives: { mask },
  computed: {
    isButtonReady() {
      return this.isFormValid
    },
    isFormValid() {
      return !this.errors.any() && this.ddd && this.cellphone && this.password
    },
  },
  methods: {
    setLoadingContained(value = true) {
      if (value === true) {
        this.setErrorMsg('')
        this.$vs.loading({
          background: 'primary',
          color: '#FFF',
          container: '#button-with-loading',
          scale: 0.45,
        })
        this.isLoadingActive = true
      } else {
        this.$vs.loading.close('#button-with-loading > .con-vs-loading')
        this.isLoadingActive = false
      }
    },
    restrictNumbers($event) {
      if (this.error) {
        this.error = null
      }
      if (/\d/.test(String.fromCharCode($event.charCode))) {
        return true
      }
      $event.preventDefault()
    },
    async signIn() {
      this.setLoadingContained(true)
      let username = `+55${this.ddd}${this.cellphone}`
      let password = this.password + '=='
      try {
        const user = await Vue.prototype.$Amplify.Auth.signIn(
          username,
          password
        )

        if (user && user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.$router
            .push({ name: 'change-password', params: { user } })
            .catch((err) => {})
        } else if (user) {
          const userGroup =
            user.signInUserSession.idToken.payload['cognito:groups'] || []

          if (!userGroup.length || !userGroup.includes('caravanists')) {
            this.setLoadingContained(false)
            return this.setErrorMsg('User does not exist.')
          }

          const userData = user.signInUserSession.idToken.payload || {}
          await AmplifyEventBus.$emit('authState', 'signedIn')
        }
      } catch (err) {
        this.setLoadingContained(false)
        const msg = strings['pt-br'][err.message] || err.message
        this.setErrorMsg(msg)
      }
    },
    setErrorMsg(msg) {
      this.errorMsg = strings['pt-br'][msg] || msg
    },
    async mounted() {
      try {
        // Check if user is authenticated
        await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
        this.$router.push({ name: 'home' })
      } catch (e) {}
    },
    created() {
      if (!appStore.isRegistered) {
        this.$store.registerModule('appStore', appStore)
        appStore.isRegistered = true
      }
    },
  },
}
</script>

<style lang="scss">
#page-login {
  .vs-input.vs-input-primary {
    min-width: 38px;
  }
  .w-full.text-sm {
    float: left;
    clear: both;
    & + .text-sm {
      margin-top: 16px;
    }
  }
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
  @media screen and (max-width: 720px) {
    .password-recovery {
      .vs-col {
        flex-direction: row;
        flex-wrap: wrap;
      }
      .password-recovery-title,
      .password-recovery-link {
        margin: 0 !important;
        width: 100%;
        flex: 1 0 100% !important;
        text-align: center;
        span {
          width: 100%;
        }
      }
    }
  }
}
</style>
